import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import {jwtDecode} from "jwt-decode";

const isAuthenticated = () => {
  const token = localStorage.getItem("accessToken");
  if (!token) return false;

  try {
    const { exp } = jwtDecode(token);
    if (exp * 1000 < Date.now()) {
      // Token is expired
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
       // Optional: Clear the token from storage
      return false;
    }
    return true;
  } catch (error) {
    // Invalid token format
    return false;
  }
};


const PrivateRoute = () => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" />;
  }
  return <Outlet />;
};

export default PrivateRoute;